import styled from 'styled-components';
import { Colors, FontSizes } from 'core/CssVariables';

export const SReleaseNotesWrapper = styled.div`
  display: flex;
  gap: 16px;
  min-height: 400px;
`;

export const SReleaseList = styled.div`
  width: 180px;
  min-width: 180px;
  border-right: 1px solid ${Colors.LightBorderColor};
  padding-right: 16px;

  .release-list-title {
    font-size: ${FontSizes.FontSM}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${Colors.LightBorderColor};
  }
`;

export const SReleaseItem = styled.div<{ $isActive?: boolean }>`
  padding: 8px 12px;
  margin-bottom: 4px;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ $isActive }) =>
    $isActive ? Colors.PrimaryColor : 'transparent'};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? Colors.PrimaryColor : Colors.LightBackground};
  }

  .version {
    font-size: ${FontSizes.FontSM}px;
    font-weight: 600;
    color: ${({ $isActive, theme }) =>
      $isActive ? Colors.White : theme.color};
  }

  .date {
    font-size: ${FontSizes.FontXS}px;
    color: ${({ $isActive }) => ($isActive ? Colors.White : Colors.Grey)};
    opacity: ${({ $isActive }) => ($isActive ? 0.9 : 1)};
  }

  .current-badge {
    font-size: 10px;
    background-color: ${({ $isActive }) =>
      $isActive ? 'rgba(255,255,255,0.2)' : Colors.SuccessColor};
    color: ${Colors.White};
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: 4px;
  }
`;

export const SReleaseNotesContent = styled.div`
  flex: 1;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;

  h1 {
    font-size: ${FontSizes.FontXL}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-bottom: 16px;
    border-bottom: 1px solid ${Colors.LightBorderColor};
    padding-bottom: 8px;
  }

  h2 {
    font-size: ${FontSizes.FontLG}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-top: 24px;
    margin-bottom: 12px;
  }

  h3 {
    font-size: ${FontSizes.FontMD}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-top: 16px;
    margin-bottom: 8px;
  }

  p {
    font-size: ${FontSizes.FontSM}px;
    color: ${({ theme }) => theme.color};
    margin-bottom: 12px;
    line-height: 1.6;
  }

  ul,
  ol {
    margin-bottom: 12px;
    padding-left: 24px;
  }

  li {
    font-size: ${FontSizes.FontSM}px;
    color: ${({ theme }) => theme.color};
    margin-bottom: 4px;
    line-height: 1.5;
  }

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.color};
  }

  code {
    background-color: ${Colors.LightBackground};
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    font-size: ${FontSizes.FontXS}px;
  }

  pre {
    background-color: ${Colors.LightBackground};
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin-bottom: 12px;

    code {
      background-color: transparent;
      padding: 0;
    }
  }

  hr {
    border: none;
    border-top: 1px solid ${Colors.LightBorderColor};
    margin: 24px 0;
  }
`;

export const SLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;
